module.exports = __webpack_public_path__ + "static/media/c4.3970d673.jpg";